import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { LoaderBar } from '@mummssoftware/common-ui';
import defaults from '../../translations/en.json';

export type RegenerateProgress = {
  completed: number;
  total: number;
};

const AnimationWrapper = styled.div`
  .progress-enter {
    animation-duration: 0.3s;
    animation-name: ease-in-bottom;
  }

  @keyframes ease-in-bottom {
    from {
      translate: 0 -5vh;
      opacity: 0.75;
    }
    to {
      translate: 0 0;
      opacity: 1;
    }
  }
`;

const ModalLayoutDiv = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 1400;
`;

const ModalDiv = styled.div`
  width: 65vw;
  height: 30vh;
  min-height: 200px;
  max-height: 400px;
  background-color: var(--mumms-paper);
  border: 4px solid black;
  border-radius: 1vw;

  @media only screen and (max-device-width: 1112px) {
    max-height: 300px;
  }
`;

const LayoutWrapper = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5vh;
`;

const TitleWrapper = styled.div`
  padding-bottom: 1vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 80%;
`;

const MummsLogo = (
  <img
    src={`${process.env.PUBLIC_URL}/assets/logo-512.png`}
    alt="mumms-logo"
    width="40vw"
  />
);

const withStyles = makeStyles((theme: any) => ({
  text: {
    color: theme.palette.text.primary,
  },
}));

export const RegenerateLoader = ({
  progress,
}: {
  progress: RegenerateProgress | null;
}) => {
  const [animationClass, setAnimationClass] = useState('progress-enter');
  const classes = withStyles();

  useEffect(() => {
    setAnimationClass('progress-enter');
    const timer = setTimeout(() => setAnimationClass(''), 300);
    return () => clearTimeout(timer);
  }, []);

  const percent =
    progress && progress.total > 0 ? progress.completed / progress.total : 0;

  const message =
    progress && progress.total > 0
      ? `${defaults.regenerating} (${progress.completed}/${progress.total})`
      : defaults.regenerating;

  return (
    <AnimationWrapper>
      <ModalLayoutDiv className={animationClass}>
        <ModalDiv>
          <LayoutWrapper>
            <TitleWrapper>
              <div>{MummsLogo}</div>
              <div
                className={classes.text}
                style={{ fontSize: '2rem', fontWeight: 'bold' }}
              >
                {defaults.regenerateTitle}
              </div>
            </TitleWrapper>
            <div style={{ width: '80%' }}>
              <LoaderBar value={percent} />
            </div>
            <div className={classes.text} style={{ fontSize: '1.1rem' }}>
              {message}
            </div>
          </LayoutWrapper>
        </ModalDiv>
      </ModalLayoutDiv>
    </AnimationWrapper>
  );
};
